"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkOverrides = void 0;
/**
 * @copyright
 * Copyright (c) 2024 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
const overrides_1 = require("../FedmodBadge/overrides");
const checkOverrides = (scope, defaultUrl) => {
    if (typeof window === "undefined") {
        return defaultUrl;
    }
    const name = scope.replace("_client", "");
    const list = (0, overrides_1.parseSearchParams)(location.href, [name]);
    if (list.size > 0) {
        return list.get(name);
    }
    if (localStorage.getItem(name)) {
        return localStorage.getItem(name);
    }
    // stay backwards compatible
    if (localStorage.getItem(scope)) {
        return localStorage.getItem(scope);
    }
    return defaultUrl;
};
exports.checkOverrides = checkOverrides;
